import { Routes, Route } from "react-router-dom";
import Landing      from "@/routes/Landing";
import Dashboard    from "@/routes/Dashboard";
import Login        from "@/routes/Login";
import Subscribe    from "@/routes/Subscribe";
import Leaderboard  from "@/routes/Leaderboard";
import Profile      from "@/routes/Profile";
import Streak       from "@/routes/Streak";
import Learn          from "@/routes/Learn";
import Quiz           from "@/routes/Quiz";
import SentenceBuilder from "@/routes/SentenceBuilder";
import SpeedReview    from "@/routes/SpeedReview";
import Revise         from "@/routes/Revise";
import Assistance     from "@/routes/Assistance";
import { Onboarding, MfaVerify, ResetPassword, SignedOut, NotFound } from "@/routes/auth-pages";
import { Terms, Privacy } from "@/routes/legal-pages";
import { RequireAuth, RequireAccess, RedirectIfAuthed } from "@/components/route-guards";

export default function App() {
  return (
    <Routes>
      {/* Marketing — always public */}
      <Route path="/"          element={<Landing />} />
      <Route path="/terms"     element={<Terms />} />
      <Route path="/privacy"   element={<Privacy />} />

      {/* Auth surfaces — bounce signed-in users away from /login */}
      <Route path="/login"           element={<RedirectIfAuthed><Login /></RedirectIfAuthed>} />
      <Route path="/reset-password"  element={<ResetPassword />} />
      <Route path="/mfa-verify"      element={<MfaVerify />} />
      <Route path="/signed-out"      element={<SignedOut />} />

      {/* Auth-required but NOT license-gated */}
      <Route path="/onboarding" element={<RequireAuth><Onboarding /></RequireAuth>} />
      <Route path="/subscribe"  element={<RequireAuth><Subscribe /></RequireAuth>} />

      {/* App surfaces — auth + onboarding + license required */}
      <Route path="/dashboard"        element={<RequireAccess><Dashboard /></RequireAccess>} />
      <Route path="/learn"            element={<RequireAccess><Learn /></RequireAccess>} />
      <Route path="/quiz"             element={<RequireAccess><Quiz /></RequireAccess>} />
      <Route path="/speed-review"     element={<RequireAccess><SpeedReview /></RequireAccess>} />
      <Route path="/revise"           element={<RequireAccess><Revise /></RequireAccess>} />
      <Route path="/assistance"       element={<RequireAccess><Assistance /></RequireAccess>} />
      <Route path="/sentence-builder" element={<RequireAccess><SentenceBuilder /></RequireAccess>} />
      <Route path="/leaderboard"      element={<RequireAccess><Leaderboard /></RequireAccess>} />
      <Route path="/profile"          element={<RequireAuth><Profile /></RequireAuth>} />
      <Route path="/streak"           element={<RequireAccess><Streak /></RequireAccess>} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
